<template>
  <div>
    <Pos_history_import/>
  </div>
</template>

<script>
import Pos_history_import from "@/components/adminArin/pos_system/warehouse/inventory/Pos_history_import";
export default {
  name: "PosHistoryImport",
  components: {
    Pos_history_import
  }
}
</script>

<style scoped>

</style>
